import { Dialog, DialogContent, DialogActions, Button, IconButton, makeStyles } from '@material-ui/core'
import { ArrowForwardIos, ArrowBackIos } from '@material-ui/icons'
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(2),
    overflowX: 'hidden',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    width: 'auto', 
    height: 'auto'
  },
  navigationButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    zIndex: 1,
  },
  leftButton: {
    left: -16,
  },
  rightButton: {
    right: -20, 
  },
  image: {
    maxWidth: '90%',
    maxHeight: '100%',
    borderRadius: 8,
    objectFit: 'contain',
  },
  dialogContentText: {
    textAlign: 'center',
    // height: '70vh', 
    // minHeight: '56vh',
    margin: 0
  },
  imageCounter: {
    flexGrow: 1,
    textAlign: 'center',
    fontSize: '1.1rem',
    paddingLeft: '11%'
  },
  dialogPaper: {
    maxheight: '85vh',
    width: 'auto',
    height: 'auto',
  },
}))

const ImageContainer = ({ images, selectedImageIndex, handleClose }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [currentIndex, setCurrentIndex] = useState(selectedImageIndex)

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : images.length - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex < images.length - 1 ? prevIndex + 1 : 0))
  }

  return (
    <Dialog open={selectedImageIndex !== null} onClose={handleClose} PaperProps={{ className: classes.dialogPaper }}>
      <DialogContent className={`${classes.dialogContent} ${classes.dialogContentText}`}>
        <div className={classes.imageContainer}>
            {images.length > 1 && (
              <IconButton className={`${classes.navigationButton} ${classes.leftButton}`} onClick={handlePrev}>
                <ArrowBackIos />
              </IconButton>
            )}
            <img
              src={images[currentIndex]}
              alt="Box Image"
              className={classes.image}
            />
            {images.length > 1 && (
              <IconButton className={`${classes.navigationButton} ${classes.rightButton}`} onClick={handleNext}>
                <ArrowForwardIos />
              </IconButton>
            )}
          </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.imageCounter}>
          {currentIndex + 1} / {images.length}
        </div>
        <Button onClick={handleClose} color="primary">
          {`${t('dataEntry.close')}`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

ImageContainer.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedImageIndex: PropTypes.number,
  handleClose: PropTypes.func.isRequired,
}

export default ImageContainer
